<template>
    <div>

        <basic-table
        :items="tlinks"
        :fields="fields">
        </basic-table>
    </div>
</template>

<script>

export default {
  props: {
    acc_id: null
  },
  data () {
    return {
      fields: [
        {key: 'tariff_id', label: 'ID', sortable: true, sortDirection: 'desc'},
        {key: 'link_date', label: this.$i18n.t('Active since'), sortable: true, sortDirection: 'desc', formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'unlink_date', label: this.$i18n.t('Active till'), sortable: true, sortDirection: 'desc', formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'tariff_name', label: this.$i18n.t('Tariff name'), sortable: true, sortDirection: 'desc'}
      ]
    }
  },
  methods: {
    intToDate (val) {
      return this.$root.showDataWithTZDelta(val)
    }
  },
  computed: {
    tlinks () {
      return this.$store.getters['Tariffing/TARIFF_LINKS_HISTORY']
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TARIFF_LINKS_HISTORY', this.acc_id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/tariffLinks/history.vue